import r from "../managers/braze-instance.js";
import tr from "./feature-flags-provider-factory.js";
function ar(e, t, a = !1) {
  if (r.rr()) return tr.m().refreshFeatureFlags(e, t, a);
}
export function refreshFeatureFlags(r, e) {
  ar(r, e);
}
export default ar;
